module.exports = __webpack_public_path__ + "static/media/23_plantilla_combo_rectangular_marco_comida_56.7af86010.png";